export default __webpack_public_path__ + "static/img3-0ed74f5e51a5e35deb0701bb4ccc5164.jpg";